import React from 'react'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'

const LoaderContainer = styled.div`
  display: flex;
  gap: ${rem(12)};

  ${mediaQueryUp.tablet} {
    display: grid;
    grid-template-rows: min-content 1fr;
    gap: 0;
    min-height: ${rem(400)};
  }
`

const ImageBox = styled(LoadingBox)`
  width: ${rem(102)};
  flex-shrink: 0;
  border-radius: ${(props) => props.theme.borderRadius.M};

  ${mediaQueryUp.tablet} {
    width: 100%;
    height: ${rem(162)};
    border-radius: 0;
  }
`

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  padding: ${rem(8)} 0;

  ${mediaQueryUp.tablet} {
    justify-content: space-between;
    padding: ${rem(20)} 0;
  }
`

const UrgencyLabelLoadingBox = styled(LoadingBox)`
  height: ${rem(24)};
  width: ${rem(72)};
  border-radius: ${(props) => props.theme.borderRadius.S};
`

const Footer = styled.div`
  margin-top: ${rem(8)};
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`

const PriceRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
`

interface Props {
  className?: string;
}

function ExperienceCompactSearchTileSkeleton(props: Props) {
  return (
    <LoaderContainer className={props.className}>
      <ImageBox />
      <Content>
        <div>
          <VerticalSpacer gap={8}>
            <UrgencyLabelLoadingBox />
            <div>
              <TextLoadingBox typography="body-small" width={96} />
              <TextLoadingBox typography="caption-large" width="100%" />
              <TextLoadingBox typography="caption-large" width={148} />
            </div>
          </VerticalSpacer>
        </div>
        <Footer>
          <div>
            <TextLoadingBox typography="caption-large" width={28} />
            <PriceRow>
              <TextLoadingBox typography="heading6" width={92} />
            </PriceRow>
          </div>
        </Footer>
      </Content>
    </LoaderContainer>
  )
}

export default ExperienceCompactSearchTileSkeleton
